/* src/app/views/template/components/templates/web/web-templates.component.scss */
/*# sourceMappingURL=web-templates.component.css.map */
